module.exports = __webpack_public_path__ + "img/znfxxjxt.1a2d7fb5.png";